import * as React from "react"
import Footer from "../components/footer"
import Navbar from "../components/navbar"
import Sobre from "../components/sections/sobre"

/*
 * Sobre now lives on the home page, which is one scrolling document. This
 * route is kept so links to /about/ shared before the merge still resolve —
 * it renders the same section, on its own. Nothing links here any more.
 */
export default function About() {
  return (
    <React.Fragment>
      <Navbar />
      <Sobre />
      <Footer />
    </React.Fragment>
  )
}
